import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "uk-grid": "" }
const _hoisted_2 = { class: "uk-width-1-2" }
const _hoisted_3 = { class: "uk-width-1-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chat_table = _resolveComponent("chat-table")!
  const _component_ChatDetails = _resolveComponent("ChatDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_chat_table, { onSelectChat: _ctx.selectChat }, null, 8, ["onSelectChat"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ChatDetails)
    ])
  ]))
}